export const SHARE_LINK_TOKEN_HEADER = 'skand-share-link-token';
